import classNames from 'classnames';
import IconClose from 'public/static/images/icons/Close.svg';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { ModalProps } from '~components/Modal/Modal.types';
import { NextUtils } from '~helpers/NextUtils';

import styles from './Modal.module.scss';

export function Modal({ children, active, onClose, mods }: ModalProps) {
  useEffect(() => {
    document.body.style.overflow = active ? 'hidden' : '';
  }, [active]);

  if (!active || NextUtils.isServer()) {
    return null;
  }

  function handleClose() {
    document.body.style.overflow = '';
    onClose();
  }

  const closeButton = (
    <button className={styles.close} onClick={handleClose}>
      <IconClose />
    </button>
  );

  return createPortal(
    <div
      className={classNames(
        styles.popup,
        mods?.map((mod) => styles[mod]),
      )}
    >
      <div className={styles.overlay} onClick={handleClose} />
      <div className={styles.inner}>
        {closeButton}
        <div className={styles.body}> {children}</div>
      </div>
      {closeButton}
    </div>,
    document.body,
  );
}
